if (!customElements.get('sticky-buy-buttons')) {
	class StickyBuyButtons extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			if (this.#scrollHandler) return

			this.#scrollHandler = this.#onScroll.bind(this)
			this.#resizeHandler = this.#onResize.bind(this)

			this.#updateTriggerOffset()

			window.addEventListener('scroll', this.#scrollHandler, { passive: true })
			window.addEventListener('resize', this.#resizeHandler)

			// Ensure we start from the right state once layout is fully ready
			requestAnimationFrame(() => {
				this.#updateTriggerOffset()
				this.#onScroll()
			})
		}

		disconnectedCallback() {
			if (this.#scrollHandler) {
				window.removeEventListener('scroll', this.#scrollHandler)
			}

			if (this.#resizeHandler) {
				window.removeEventListener('resize', this.#resizeHandler)
			}

			this.#scrollHandler = undefined
			this.#resizeHandler = undefined
			this.#triggerOffset = 0

			this.#unsetFixed()
		}

		#onScroll() {
			const shouldFix = window.scrollY > this.#triggerOffset

			if (shouldFix) {
				this.#setFixed()
			} else {
				this.#unsetFixed()
			}
		}

		#onResize() {
			const wasFixed = this.#isFixed
			if (wasFixed) {
				this.#unsetFixed()
			}

			this.#updateTriggerOffset()
			this.#onScroll()

			if (wasFixed && window.scrollY > this.#triggerOffset) {
				this.#setFixed()
			}
		}

		#updateTriggerOffset() {
			if (!this.isConnected) return

			const { top } = this.getBoundingClientRect()
			this.#triggerOffset = window.scrollY + top
		}

		#setFixed() {
			if (this.#isFixed) return

			const currentHeight = this.getBoundingClientRect().height
			this.#insertPlaceholder(currentHeight)
			this.classList.add(
				'max-md:fixed',
				'max-md:bottom-0',
				'max-md:left-0',
				'max-md:right-0',
				'max-md:z-10',
				'max-md:px-4',
				'max-md:pt-4',
				'max-md:bg-white',
				'max-md:mb-0'
			)
			this.#isFixed = true

			requestAnimationFrame(() => {
				if (!this.#isFixed) return
				this.#syncPlaceholderHeight()
			})
		}

		#unsetFixed() {
			if (!this.#isFixed) return

			this.classList.remove(
				'max-md:fixed',
				'max-md:bottom-0',
				'max-md:left-0',
				'max-md:right-0',
				'max-md:z-10',
				'max-md:px-4',
				'max-md:pt-4',
				'max-md:bg-white',
				'max-md:mb-0'
			)
			this.#removePlaceholder()
			this.#isFixed = false
		}

		#insertPlaceholder(initialHeight) {
			if (this.#placeholder || !this.parentElement) return

			this.#placeholder = document.createElement('div')
			this.#placeholder.setAttribute('aria-hidden', 'true')
			this.#placeholder.style.width = '100%'
			this.#placeholder.style.pointerEvents = 'none'
			this.parentElement.insertBefore(this.#placeholder, this)

			if (typeof initialHeight === 'number') {
				this.#placeholder.style.height = `${initialHeight}px`
			}
		}

		#syncPlaceholderHeight() {
			if (!this.#placeholder) return

			const height = this.offsetHeight
			this.#placeholder.style.height = `${height}px`
		}

		#removePlaceholder() {
			if (!this.#placeholder) return

			this.#placeholder.remove()
			this.#placeholder = undefined
		}

		#scrollHandler
		#resizeHandler
		#triggerOffset = 0
		#isFixed = false
		#placeholder
	}

	customElements.define('sticky-buy-buttons', StickyBuyButtons)
}
